import { useEffect, useState } from 'react';
import axios from '../../api/appPublicApi';
import { Box, Tabs, Tab } from '@mui/material';
import { styled } from '@mui/material/styles';
import TkLandingCards from './components/LandingPage/TkLandingCards';
import { useSearchParams } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

const TkLandingPage = () => {
  const [searchParams] = useSearchParams();
  const theme = useTheme();

  const [value, setValue] = useState(0);
  const [sortedData, setSortedData] = useState([]);
  const [integrationTags, setIntegrationTags] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const [fetchIntegrations, fetchTags] = await Promise.all([
        axios.get('/api/app/integrations/getIntegrationData'),
        axios.get('/api/app/integrations/getIntegrationTags'),
      ]);

      const integrationData = fetchIntegrations.data.sort((a, b) => a.name.localeCompare(b.name));
      const tags = fetchTags.data.sort((a, b) => a.sort_order - b.sort_order);

      setSortedData(integrationData);
      setIntegrationTags(tags);
    };

    fetchData();
  }, []);

  useEffect(() => {
    const integrationType = searchParams.get('type');
    if (integrationType != null) {
      setValue(Number(integrationType));
    }
  }, []);

  const ModernTab = styled(Tab)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    paddingBottom: 8,
    transition: 'all 0.35s ease',
    color: '#c9c9c9',
    '&.Mui-selected': {
      fontWeight: 'bold',
      // color: '#fff',
    },
    fontSize: '0.7rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.3rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.5rem',
    },
    [theme.breakpoints.up('xl')]: {
      fontSize: '1.85rem',
    },
  }));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const selectedTag = integrationTags[value - 1];
  const displayedPlatforms = selectedTag
    ? sortedData.filter((platform) => platform.tag_codes?.includes(selectedTag.tag_code))
    : sortedData;

  return (
    <Box sx={{}}>
      <Box
        sx={{
          display: 'flex',
          height: '60px',
          width: '100%',
          background: theme.palette.primary.main,
          zIndex: 1,
          alignItems: 'center',
        }}
      >
        <img width='225px' height='auto' src='/images/turnkey/SS_Logo.png' alt='Sports South' />
        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            transform: 'translate(-50%, 0%)',
            display: { xs: 'none', sm: 'block' },
            color: '#fff',
            fontSize: '1.9em',
          }}
        >
          Connected Platforms
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mx: 'auto',
          flexDirection: 'column',
          width: '95%',
          maxWidth: '1600px',
          pt: 1.5,
          gap: 4,
          background: theme.palette.background.paper,
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          centered
          sx={{
            // borderBottom: 4,
            // boxShadow: 4,
            // padding: 1.5,
            // pb: 2,
            // borderColor: theme.palette.primary.main,
            // borderRadius: 2,
            // bgcolor: `${theme.palette.primary.main}`,
            width: { xs: '100%', xl: '58%' },
            display: 'flex',
            mx: 'auto',
            // justifyContent: 'center',
            '& .MuiTabs-indicator': {
              height: { xs: 3, sm: 5 },
            },
          }}
        >
          <ModernTab label='All' value={0} />
          {integrationTags.map((tag, index) => (
            <ModernTab key={tag.tag_code} label={tag.description} value={index + 1} />
          ))}
        </Tabs>

        <Box sx={{ mb: 4 }}>
          <TkLandingCards data={displayedPlatforms} />
        </Box>
      </Box>
    </Box>
  );
};

export default TkLandingPage;
